import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const CustomButtonWrapper = styled.button<{
  statusColor: 'success' | 'warning' | 'redFlag' | string;
  fullWidth: boolean;
  fontSize: string;
  fontFamily: string;
  BGColor: string;
  borderColor: string;
  iconDirection: string;
  justify: string;
  disabled:boolean;
}>`
  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  display: flex;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: center;
  flex-direction: ${(props) =>
    props.iconDirection ? props.iconDirection : 'row'};
  gap: calc(${theme.space_size} / 2);
  font-size: ${(props) => props.fontSize};
  font-family: ${(props) => props.fontFamily};
  border-radius: calc(${theme.space_size} * 1.5);
  /* padding: 12px; */
  height: 41px;
  background-color: ${(props) => props.BGColor};
  cursor: pointer;
  color: ${(props) =>
    props.statusColor === 'success'
      ? `${theme.colours.blackText}`
      : props.statusColor === 'redFlag'
      ? `${theme.colours.red_2}`
      : props.statusColor === 'warning'
      ? `${theme.colours.Gamboge}`
      : props.statusColor === 'info'
      ? `${theme.colours.AntiFlashWhite}`
      : props.statusColor};

  border: ${(props) =>
    props.borderColor === 'success'
      ? `1px solid ${theme.colours.blackText}`
      : props.borderColor === 'redFlag'
      ? `1px solid ${theme.colours.red_2}`
      : props.borderColor === 'warning'
      ? `1px solid ${theme.colours.Gamboge}`
      : props.borderColor === 'info'
      ? `${theme.colours.AntiFlashWhite}`
      : `1px solid ${props.borderColor}`};
  span {
    .icon {
      width: 11px;
      height: 11px;
      svg {
        width: 100%;
      }
    }
  }
`;
